import { newAlertify } from 'trunks/vue/admin/components/alert.js';
import ResponseMixin from 'trunks/vue/share/mixins/response.js';
import ResponseFieldListFieldable from 'trunks/vue/admin/components/response_fields/list/fieldable.js';

export default {
  mixins: [ResponseMixin],

  components: {
    'field-list': ResponseFieldListFieldable,
  },

  computed: {
    hasCalculationFields() {
      return _.chain(this.fields)
        .map((field) => {
          if (field.type === 'Field::Detail') return field.children;
          return field;
        })
        .flatten()
        .any({ type: 'Field::Calculation' })
        .value();
    },
  },

  created() {
    if (!this.response.isPersisted()) {
      this._bindCacheEvent();
      this._restoreDraftEntries();
    }
  },

  methods: {
    isValid() {
      if (!this.valid) {
        newAlertify('填写不合法', {
          type: 'error',
        });
        this.$refs.fieldsView.displayFirstError();
      }
      return this.valid;
    },
  },
};
